import { Skeleton } from "@/components/ui/skeleton";

export const CoachingSectionSkeleton = ({ label, rows = 3 }) => (
  <section
    aria-busy="true"
    aria-live="polite"
    className="app-card p-5 sm:p-6"
  >
    <div className="flex items-center justify-between mb-3">
      <div className="card-label">{label || "Loading"}</div>
    </div>
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, idx) => (
        <Skeleton key={idx} className="h-4 w-full" />
      ))}
    </div>
  </section>
);

export const CoachingHomeSkeleton = () => (
  <div className="space-y-6">
    <CoachingSectionSkeleton label="Today" rows={4} />
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <CoachingSectionSkeleton label="Why this workout" rows={3} />
      <CoachingSectionSkeleton label="What to focus on" rows={3} />
    </div>
    <CoachingSectionSkeleton label="This week" rows={5} />
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <CoachingSectionSkeleton label="Last session" rows={3} />
      <CoachingSectionSkeleton label="Plan change" rows={3} />
    </div>
  </div>
);
